// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mLeL","newExpiryDate":"styles_newExpiryDate__eoRzV","footer":"styles_footer__2Z6EN"};